export const VERIFY_EMAIL_ADDRESS = {
  root: 'verify-email-address',
  resend: 'resend-email',
  loginWithPhone: 'login-with-phone',
  checkout: 'verify-email-address-checkout-as-guest',
  id: 'verify-email-address-id',
  backIcon: 'back-to-login'
};
